import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { useHistory } from 'src/lib/hooks/useHistory';
import { usePopups } from 'src/lib/popups';
import { ROUTES } from 'src/routes';
import { useErrorHandler } from 'src/services';
import {
  useCurrentCustomerId,
  useCustomerActions,
  useNotificationActions,
  useWorkspaceActions,
} from 'src/store';

import { WorkspacePopup } from './WorkspacePopup';

export const WORKSPACE_POPUP = Symbol('WORKSPACE');

export const useWorkspacePopup = () => {
  const popups = usePopups();
  const currentCustomerId = useCurrentCustomerId();
  const customerActions = useCustomerActions();
  const workspaceStoreActions = useWorkspaceActions();
  const notificationActions = useNotificationActions();
  const handleError = useErrorHandler();
  const history = useHistory();

  useEffectOnce(() => {
    popups.registerPopup(WORKSPACE_POPUP, WorkspacePopup);
  });

  return useCallback(
    (workspace) => {
      popups.openPopup(WORKSPACE_POPUP, {
        workspace,
        onConfirm: async (item) => {
          // TODO: we should not close popup until changes are saved, disable popup while saving
          popups.closePopup(WORKSPACE_POPUP);

          try {
            if (workspace?.id) {
              await workspaceStoreActions.updateWorkspace({
                ...item,
                id: workspace.id,
              });
              notificationActions.displaySuccess(`Workspace '${item.name}' updated`);
            } else {
              await workspaceStoreActions.createWorkspace({
                ...item,
                customerId: currentCustomerId,
              });
              notificationActions.displaySuccess(`Workspace '${item.name}' created`);
              customerActions.refreshCurrentCustomerFeatureLimit();
              history.push(ROUTES.ROOT);
            }
          } catch (error) {
            handleError(error);
          }
        },
        onCancel: () => {
          popups.closePopup(WORKSPACE_POPUP);
        },
      });
    },
    [
      popups,
      workspaceStoreActions,
      currentCustomerId,
      notificationActions,
      handleError,
      customerActions,
      history,
    ]
  );
};
